import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private api : ApiService) { }

    getInvoiceInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ems-service/invoice/getInvoiceInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
    } 

    addOrUpdate(formData:any){
        const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/addOrUpdate')
        return this.api.post(url,formData);
    }

    checkMatrices(formData:any){
        const url = (environment.New_BASE_DOMAIN + 'ems-service/approval/checkMatrices')
        return this.api.post(url,formData);
    }


    approveInvoice(formData:any){
      const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/approveInvoice')
      return this.api.post(url,formData);
  }
  updateInvoiceLineItem(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/updateInvoiceLineItem')
    return this.api.post(url,formData);
  }
  approveInvoiceLineItem(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/approveInvoiceLineItem')
    return this.api.post(url,formData);
  }

  updateBudget(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/addOrUpdate')
    return this.api.post(url,formData);
}
approveBudget(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/approveBudget')
  return this.api.post(url,formData);
}
getInvoiceLineItem(date:any,ids:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/invoice/getInvoiceLineItem?expenseIds=${ids}&invoiceDate=${date}`;
  return this.api.get(url);
}
getBudgetItem(ids:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/budget/getBudgetById?budgetId=${ids}`;
  return this.api.get(url);
}

multiApproveInvoice(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/invoice/multiApproveInvoice')
  return this.api.post(url,formData);
}
}
